import React, { Fragment } from 'react'
const QuickSnapshot = ({snapShotData,image}) => {

    return (
        <div className={`p-5 md:pl-6 md:py-5 sm:m-10 ava-card-bg  ava-radius-md  ava-card-mukta`} 
        // style={{border:"1px solid black"}}
        >
            <div className='md:px-5 flex md:flex-row flex-col  items-start justify-between gap-6 md:gap-3 '>
                {/* Left section */}
                <div className='flex flex-col items-start gap-3 max-w-xl md:pt-5'>
                    <h2 className="ava-heading-md ">Quick Snapshot </h2>
                    {snapShotData.map((item, index) => (
                        <div key={index}
                        //  className={` ${styles.snapshotText}`}
                         >
                            <span className='ava-text-subheading '>{item.label}:</span>{" "}
                            <span className={`ava-text-body `}>{item.value}</span>
                        </div>
                    ))}
                </div>
                {/* Right section */}
                <div className="w-full md:w-[420px]">
                    <div className="w-full h-[220px] md:h-[260px] lg:h-[260px] ">
                        <img
                            // src="/Programs/gynacImage.jpg"
                            src={image}
                            alt="Program Gynac pic"
                            className="w-full h-full object-cover ava-radius-md ava-card-image"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuickSnapshot